import { Company } from "core/types";

export function getMainIkNumber(
  company: Company | undefined | null,
): number | undefined {
  const mainDetail = company?.ik_numbers_details?.find((d) => d.is_main);
  if (mainDetail) return mainDetail.ik_number;
  return company?.ik_numbers?.[0];
}
